import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum ScheduleRecognitionReviewColumn {
    DATE = "date",
    SCHEDULE = "schedule",
    SOURCE = "source",
    COUNTERPARTY = "counterparty",
    HOLDING_GL = "holdingGl",
    RECOGNITION_GL = "recognitionGl",
    PERIOD = "period",
    AMOUNT = "amount",
}

const makeColumnSchema = (id: ScheduleRecognitionReviewColumn) =>
    ColumnSchema.extend({ id: z.literal(id) });

export const ScheduleRecognitionReviewViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.SCHEDULE_RECOGNITION_REVIEW),
    columns: z.array(
        z.discriminatedUnion("id", [
            makeColumnSchema(ScheduleRecognitionReviewColumn.DATE),
            makeColumnSchema(ScheduleRecognitionReviewColumn.SCHEDULE),
            makeColumnSchema(ScheduleRecognitionReviewColumn.SOURCE),
            makeColumnSchema(ScheduleRecognitionReviewColumn.COUNTERPARTY),
            makeColumnSchema(ScheduleRecognitionReviewColumn.HOLDING_GL),
            makeColumnSchema(ScheduleRecognitionReviewColumn.RECOGNITION_GL),
            makeColumnSchema(ScheduleRecognitionReviewColumn.PERIOD),
            makeColumnSchema(ScheduleRecognitionReviewColumn.AMOUNT),
        ]),
    ),
});

export type ScheduleRecognitionReviewView = z.infer<
    typeof ScheduleRecognitionReviewViewSchema
>;
